import GeodesicService from "../geodesic.service";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API Base URL:", API_BASE_URL);

export const getPalette = async (domains, from, to, variables, signal) => {
  const response = await fetch(`${API_BASE_URL}/api/heatmap/palette`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    signal,
    body: JSON.stringify({
      sourceId: domains[0].sourceId,
      domainsId: domains.map((d) => d.id),
      from,
      to,
      variables,
    }),
  });
  return response.json();
};

export const getLayerForTime = async (
  date,
  domain,
  minValue,
  maxValue,
  variables,
  zoom,
  signal
) => {
  try {
    console.log(GeodesicService.getViewBounds());
    const response = await fetch(`${API_BASE_URL}/api/heatmap/data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sourceId: domain.sourceId,
        domainId: domain.id,
        date,
        minValue,
        maxValue,
        variables,
        bounds: GeodesicService.getViewBounds(),
        zoom,
      }),
      signal, // Pasamos directamente el signal para control de cancelación
    });
    return response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Fetch request was canceled");
    } else {
      throw error;
    }
  }
};

export const getDateRange = async (domains) => {
  const response = await fetch(`${API_BASE_URL}/api/heatmap/daterange`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      sourceId: domains[0].sourceId,
      domainId: domains[0].id,
    }),
  });
  return response.json();
};
